export const useShowPricePerMonthPerSeatPreSeats = () => {
  return false;
};
export const useShowIncludedSeatsPreSeats = () => {
  return false;
};
export const useShowAdditionalSeatsPriceSubtextPreSeats = () => {
  return false;
};
export const useAdditionalCoreSeatPricePreSeats = () => {
  return {
    additionalCoreSeatsPrice: 0,
    loading: false
  };
};